import { ReviewSection } from '@/components/route_stepper/types';
import { JobPostMutationInput } from '../../../store/modules/job/types';

// These types are scoped specifically to the job post flow
// Job mutation types are defined in /store/modules/job/types/index.ts file

/* eslint-disable no-unused-vars */
export enum ScheduleTypes {
  REGULAR = 'regular',
  ONE_TIME = 'one-time',
  OCCASIONAL = 'occasional',
  NANNY = 'nanny',
}

/* eslint-enable no-unused-vars */
export interface JobPostDraft extends JobPostMutationInput {
  zipCode?: string;
  isPrepopulatedFromReservation?: boolean;
  headlineReviewSection?: ReviewSection;
  locationDetails?: string | null;
  URLSearchParams?: URLSearchParams | null;
  scheduleType?: ScheduleTypes | null;
}
